/*eslint-disable */

import {
  mapGetters,
  mapState
} from 'vuex';

import countries from './phone.json'
import toast from '@/services/toast';
import userImageBox from '@/components/userimage/index';

var $ = window.jQuery = require('jquery');
export default {
  name: 'userProfile',
  components: {
    'user-image': userImageBox
  },
  props: [],
  data() {
    return {
      preloader: true,
      userinfo: {},
      favouriteCourse: {},
      showblock: 'personal',
      courses: 'favourite',
      userFirstName: '',
      userLastName: '',
      userEmail: '',
      userCountry: '',
      userDOB: '',
      userOrganization: '',
      userMobile: '',
      userAddress: '',
      userCity: '',
      userPin: '',
      userOin: '',
      userfb: '',
      userlinkedin: '',
      usertwitter: '',
      userinstgram: '',
      countryList: [],
      earnedPointsState:'',
      countryCodeInteger:'',
      userQuizHistoriesData:{},
      userQuizHistoriesResults:[]
    }
  },
  computed: {
    ...mapGetters([
      'getProfileInfo',
      'lastestcourses',
      'getEnrolledCourseByNumber',
      'getUserAttemptQuizHistoriesGetters'
    ]),
    ...mapState([
      'profileInfo'
    ]),
    getEarnedPointsInfo(){
      this.earnedPointsState = this.$store.getters.contestPointsObtainedGetters.data;
      return
    },
    getUserInfo() {
      this.favouriteCourse = this.$store.getters.getEnrolledCourseByNumber.results
      this.userinfo = this.$store.state.profileStore.profileInfo.data;
      this.assignment = this.$store.state.assignmentStore.addAssignmentByNumber.results
      this.preloader = false;
      $('.app-loader').hide()
      return
    },
    getAllEnrollCourseNumber() {
      return this.$store.state.userCourses.userEnrolledCourses.count
    },
    getQuziHistoryDataFun(){
      this.userQuizHistoriesData = this.$store.getters.getUserAttemptQuizHistoriesGetters.data;
      return
    },
    setIntialQuziHistoryResults(){
        if(this.userQuizHistoriesData != undefined){
          this.userQuizHistoriesResults = this.userQuizHistoriesData.results
          return
        }
    }
  },
  mounted() {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.getUserInfo;
    this.getEarnedPointsInfo
    this.getQuziHistoryDataFun
    this.setIntialQuziHistoryResults
  },
  methods: {
    convertToJsonParse(code){
      return JSON.parse(code);
    },
    convertToAcademicJsonParse(code){
      return JSON.parse(code);
    },
    myFunction: function () {   
    window.open(this.userinfo.profile.cv, "_blank");    
    },
    getCountryCode(mobile) {
      let countryCode = mobile.split(' ')[0];
      countryCode = countryCode.replace('+', '');
      this.countryCodeInteger = countryCode.replace('+', '');
      let country = this.countryList.filter(item => (item.name) == (countryCode));
      if (country && country.length > 0) {
        country = country[0]
        country = `http://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/country/${country.value}.png`
      } else {
        country = ''
      }
      return country;
    },
    phoneFormatFunc(input) {
      var conutryCode = input.split(' ')[0]
      var mobileNumber = input.split(' ')[1]
      // Strip all characters from the input except digits
      input = mobileNumber.replace(/\D/g, '');
      // Trim the remaining input to ten characters, to preserve phone number format
      input = mobileNumber.substring(0, 10);
      // Based upon the length of the string, we add formatting as necessary
      var size = input.length;
      if (size == 0) {
        input = input;
      } else if (size < 4) {
        input = '(' + input;
      } else if (size < 7) {
        input = '(' + input.substring(0, 3) + ') ' + input.substring(3, 6);
      } else {
        input = conutryCode + ' (' + input.substring(0, 3) + ') ' + input.substring(3, 6) + ' - ' + input.substring(6, 10);
      }
      return input;
    },
    getDob: function(dob) {
      let newDate = (dob).split('-');
      newDate = newDate[0] + "/" + newDate[1] + "/" + newDate[2];
      newDate = new Date(newDate);
      newDate = newDate.formatFieldDate();
      return newDate;
    },
    showtab(value) {
      this.showblock = value;
    },
    showcourse(value) {
      this.courses = value;
    },
    getTimeandDate(timestamp) {
      return new Date(timestamp).toDateString();
      // var dateInMills = new Date(timeinMills).getDate();
      // var monthInMills = new Date(timeinMills).getMonth();
      // var yearInMills = new Date(timeinMills).getFullYear();
      // var timeInMills = new Date(timeinMills).getMinutes();
    }
    // workTypeName(workId){
    //   var workType = [{id:1, name:""},{id:2, name:""},{id:3, name:""}]
    //   return workType.filter(item => item.id == workId).name;
    // }
  },
  watch: {
    getUserInfo() {
      this.preloader = false;
      $('.app-loader').hide()
      this.favouriteCourse = this.$store.getters.getEnrolledCourseByNumber.results
      // this.userinfo = JSON.parse(localStorage.getItem('profileInfo'));
      this.userinfo = this.$store.state.profileStore.profileInfo.data;
      this.assignment = this.$store.state.assignmentStore.addAssignmentByNumber.results
      return
    },
    getAllEnrollCourseNumber() {
      return this.$store.state.userCourses.userEnrolledCourses.count
    },
    getEarnedPointsInfo(){
      return this.$store.getters.contestPointsObtainedGetters
    },
    getQuziHistoryDataFun(){
      return this.$store.getters.getUserAttemptQuizHistoriesGetters;
    },
    setIntialQuziHistoryResults(){
        if(this.userQuizHistoriesData != undefined){
          this.userQuizHistoriesResults = this.userQuizHistoriesData.results
        }
    }
  }
}